import { HttpService } from '@Services/index';
import { UboResponse, useBoundStore } from '@Store/index.ts';
import { useMutation, useQuery } from '@tanstack/react-query';

export const getBusinessOwnerData = () => {
  const businessExternalId =
    useBoundStore.getState().customer.customerData.customerBusinessData.externalId;
  const isEmbedded = useBoundStore.getState().onboardingSlice.getIsEmbedded();
  const { customerId } = useBoundStore.getState().customer;

  return { businessExternalId, isEmbedded, customerId };
};

export const getBusinessOwners = async () => {
  const { businessExternalId, isEmbedded, customerId } = getBusinessOwnerData();
  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/business/${businessExternalId}/ubo`
    : `v2/secureonboarding/user/${customerId}/business/${businessExternalId}/ubo`;
  const { data } = await HttpService.get<{ uboResponseList: UboResponse[] }>(url);
  return data?.uboResponseList;
};

export const useGetBusinessOwners = () => {
  const { businessExternalId, customerId } = getBusinessOwnerData();

  return useQuery({
    queryFn: getBusinessOwners,
    queryKey: ['getBusinessOwners'],
    enabled: !!customerId && !!businessExternalId,
  });
};

export const deleteBusinessOwner = async (uboId: string) => {
  const { businessExternalId, isEmbedded, customerId } = getBusinessOwnerData();

  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/business/${businessExternalId}/ubo/${uboId}`
    : `v2/secureonboarding/user/${customerId}/business/${businessExternalId}/ubo/${uboId}`;
  await HttpService.delete(url);
};

export const useDeleteBusinessOwner = () =>
  useMutation({
    mutationFn: deleteBusinessOwner,
  });

export const updatePrimaryOwnerPercentage = async (ownershipPercent: number) => {
  const { businessExternalId, isEmbedded, customerId } = getBusinessOwnerData();

  const url = isEmbedded
    ? `v3/secureonboarding/partner/user/${customerId}/business/${businessExternalId}/ownershipPercent`
    : `v2/secureonboarding/user/${customerId}/business/${businessExternalId}/ownershipPercent`;
  await HttpService.post(url, { ownershipPercent });
};

export const useUpdatePrimaryOwnerPercentage = () =>
  useMutation({
    mutationFn: updatePrimaryOwnerPercentage,
  });
